import add from "./addUserRole";
import remove from "./removeUserRole";

export default {
  add,
  remove,
};



// WEBPACK FOOTER //
// ./src/model/gql/mutations/users/processingUser/role/index.js